import React, { useEffect, useState } from 'react';
import api from '../../../services/api';

const Step2_Review = ({ clid, phones, segmentName, onBack, onComplete }) => {
  const [checkResults, setCheckResults] = useState(null);
  const [checking, setChecking] = useState(false);
  const [syncing, setSyncing] = useState(false);
  const [error, setError] = useState('');

  useEffect(() => {
    let cancelled = false;
    const run = async () => {
      setChecking(true);
      setError('');
      try {
        const res = await api.post('/api/toolbox/wati-contact-segment-sync/check', { clid, phones });
        if (!res.data.success) throw new Error(res.data.error || 'Failed to check contacts');
        if (!cancelled) setCheckResults(res.data.results);
      } catch (e) {
        if (!cancelled) setError(e.response?.data?.error || e.message || 'Failed to check contacts');
      } finally {
        if (!cancelled) setChecking(false);
      }
    };
    run();
    return () => {
      cancelled = true;
    };
  }, [clid, phones]);

  const missing = (checkResults || []).filter((r) => !r.exists);
  const existing = (checkResults || []).filter((r) => r.exists);

  const handleConfirm = async () => {
    setSyncing(true);
    setError('');
    try {
      const res = await api.post('/api/toolbox/wati-contact-segment-sync/sync', {
        clid,
        phones,
        segment_name: segmentName || undefined,
      });
      if (!res.data.success) throw new Error(res.data.error || 'Sync failed');
      onComplete(res.data.result);
    } catch (e) {
      setError(e.response?.data?.error || e.message || 'Sync failed');
    } finally {
      setSyncing(false);
    }
  };

  if (checking) {
    return <p className="text-gray-600">Checking contacts against WATI...</p>;
  }

  return (
    <div className="space-y-4">
      {error && <p className="text-red-600 text-sm">{error}</p>}

      <p className="text-sm text-gray-700">
        Total: {phones.length} | Already in WATI: {existing.length} | Will create: {missing.length}
      </p>

      <div className="max-h-72 overflow-y-auto border rounded">
        <table className="w-full text-sm">
          <thead className="sticky top-0 bg-gray-100">
            <tr>
              <th className="text-left p-2">Phone</th>
              <th className="text-left p-2">Status</th>
            </tr>
          </thead>
          <tbody>
            {(checkResults || []).map((r) => (
              <tr key={r.phone} className="border-t">
                <td className="p-2">{r.phone}</td>
                <td className="p-2">
                  {r.exists ? (
                    <span className="text-gray-600">Existing</span>
                  ) : (
                    <span className="text-green-700 font-medium">Will Create</span>
                  )}
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>

      <div className="flex gap-2">
        <button className="border px-4 py-2 rounded" onClick={onBack} disabled={syncing}>
          Back
        </button>
        <button
          className="bg-[#075e54] text-white px-4 py-2 rounded disabled:opacity-50"
          onClick={handleConfirm}
          disabled={syncing || !checkResults}
        >
          {syncing ? 'Processing...' : 'Confirm: Create Missing + Build Segment'}
        </button>
      </div>
    </div>
  );
};

export default Step2_Review;
